/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResourceDetailsModelList {
    getFixupPrototypeFunction() { return InventoryResourceDetailsModelList.fixupPrototype; }

    static newInstance(model: Partial<InventoryResourceDetailsModelList>): InventoryResourceDetailsModelList {
        let obj = Object.assign(new InventoryResourceDetailsModelList(), model);
        InventoryResourceDetailsModelList.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResourceDetailsModelList>): InventoryResourceDetailsModelList {
        if (!model) return null;
        return InventoryResourceDetailsModelList.newInstance(<InventoryResourceDetailsModelList> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResourceDetailsModelList) {
        if (!obj) return;

        models.InventoryResourceDetailsModelList.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResourceDetailsModelList): boolean {
        Object.setPrototypeOf(obj, InventoryResourceDetailsModelList.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * tenant_id of the resource inventory
     */
    tenant_id: string;

    /**
     * Name of the cloud
     */
    cloud: string;

    /**
     * Id of the cloud account
     */
    cloud_account_id: string;

    /**
     * Inventory summary details
     */
    cloud_account_name: string;

    /**
     * Name of the category
     */
    resource_category: string;

    /**
     * Name of the component
     */
    resource_type: string;

    /**
     * Name of the resource
     */
    resource: string;

    /**
     * Unique element for the resource
     */
    corestack_resource_id: string;

    /**
     * Tags associated with the resource
     */
    tags: any;

    /**
     * Inventory summary details
     */
    summary_details: any;

}
